import { render, staticRenderFns } from "./mo-stu-chart.vue?vue&type=template&id=bf645714&scoped=true&"
import script from "./mo-stu-chart.vue?vue&type=script&lang=js&"
export * from "./mo-stu-chart.vue?vue&type=script&lang=js&"
import style0 from "./mo-stu-chart.vue?vue&type=style&index=0&id=bf645714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf645714",
  null
  
)

export default component.exports